/**
 * Whether the notes above the `E` markers fit (charts.md, "Each `E` carries its
 * reported-EPS YoY above it").
 *
 * **Only the markers on screen count.** The first version measured every
 * marker in the chart's history, and a chart loads all of it: TSLA reported
 * twice in three days in November 2010, so that one pair hid every note on
 * every TSLA chart, at any zoom (owner, 2026-10-08).
 *
 * Pure so it can be tested without SciChart: the shell passes the marker times,
 * the visible window and a time-to-CSS-pixel function.
 */
export function notesFit(
  times: readonly number[],
  visible: { min: number; max: number },
  toPx: (time: number) => number,
  minGapPx: number,
): boolean {
  const xs = [...new Set(times)]
    .filter((t) => t >= visible.min && t <= visible.max)
    .sort((a, b) => a - b)
    .map(toPx);
  for (let i = 1; i < xs.length; i++) {
    if (xs[i]! - xs[i - 1]! < minGapPx) return false;
  }
  return true;
}
